import { MenuItem, Select } from "@mui/material";
import React, { useContext } from "react";
import { PosContext } from "../shared/PosContext";
import {
    useUpdateuserDefaults
} from "../shared/hooks/useUser";

const SimpleFloorRooms = () => {
    const { floorRooms, roomContext, refetchDefaultRoom } =
        useContext(PosContext);
    const [selectedRoom, setSelectedRoom] = roomContext;

    const updateuserDefaultsMutation = useUpdateuserDefaults();

    const handleRoomChange = (e, room) => {
        if (room) {
            setSelectedRoom(room.props.value);
            updateuserDefaultsMutation.mutate(
                {
                    key: "Room",
                    value: room.props.value.name,
                },
                {
                    onSuccess: () => {
                        refetchDefaultRoom();
                    },
                }
            );
        }
    };

    return (
        <React.Fragment>
            {floorRooms && (
                <Select
                    labelId="rooms-select-standard-label"
                    value={selectedRoom || []}
                    variant="standard"
                    onChange={handleRoomChange}
                    label={"Room"}
                >
                    {Object.keys(floorRooms).map((room, index) => (
                        <MenuItem
                            value={floorRooms[room]}
                            key={"Room_Item_" + index}
                        >
                            {room}
                        </MenuItem>
                    ))}
                </Select>
            )}
        </React.Fragment>
    );
};

export default SimpleFloorRooms;
